
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/press-and-awards",
      function () {
        return require("private-next-pages/about/press-and-awards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/press-and-awards"])
      });
    }
  